<!-- display-mobile-16 preview — a full-screen interstitial, and like placement
     15 it replaces the publisher page rather than sitting in a slot on it.
     Everything is centred on one column over the creative blurred out to fill
     the screen: the advertiser name, the headline, the description, the creative
     itself shown straight, and a pill action pinned to the floor. The dismiss
     control sits in the top-right corner and the AdChoices badge in the
     bottom-left, both over the blurred ground. -->
<app-mobile-frame>
  <!-- START: Interstitial -->
  <div class="da-unit">
    <!-- The creative again, blurred past recognition and cropped to cover: it is
         the unit's ground here, not the picture, and the picture itself is
         further down. Decorative on purpose — every part of the ad the reader
         can act on is a link of its own below. -->
    <img *ngIf="creativeImage" class="da-backdrop" [src]="creativeImage" alt="" aria-hidden="true" />

    <!-- Dismiss control and AdChoices badge: both are chrome the network draws
         over the unit, so they are decorative here. -->
    <span
      class="da-close d-flex align-items-center justify-content-center"
      aria-hidden="true"
    >
      <i class="bi bi-x-lg"></i>
    </span>

    <span
      class="da-adchoices d-flex align-items-center justify-content-center"
      aria-hidden="true"
    >
      <i class="bi bi-info-circle"></i>
    </span>

    <!-- START: Copy -->
    <div class="da-content d-flex flex-column align-items-center">
      <!-- GenSingleImagePreviewData carries no advertiser field, so the name is
           a literal here, the same compromise the other placements make. -->
      <div class="da-advertiser">Valamar</div>

      <div class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </div>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
        <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>
      </a>

      <a
        [href]="data.url" target="_blank" rel="noopener noreferrer"
        class="da-cta d-flex align-items-center justify-content-center"
      >
        <span class="da-cta-label">{{ data.ctaText || "Your call to action" }}</span>
      </a>
    </div>
    <!-- END: Copy -->
  </div>
  <!-- END: Interstitial -->
</app-mobile-frame>
